<template>
  <div>
    <div>
      <div v-if="showAlert" style="width: 200px;text-align: center;margin:auto;" @click="missingInformation">
        <v-alert
          outlined
          type="error"
          style="font-size: 10px;padding: 5px;text-align: center;margin-top: 10px;cursor: pointer">
          {{ $t('Missing Data') }}
        </v-alert>
      </div>
      <v-dialog v-model="dialogMissingInv" width="500">
        <v-card>
          <InvoiceMissingInformation v-if="!loading && currentInvoice && files[0]" :invoice="currentInvoice" :file="files[0].originalName" :forward="true" @back="closeModalInvoice" @update="closeModalInvoice" />
        </v-card>
      </v-dialog>
      <div v-if="currentInvoice" style="overflow-y: auto; overflow-x: hidden;" :style="{ display: 'table', width: '100%', height: '100%'}">
        <InvoiceImage v-if="files[0]" ref="invoiceImage" :image="files[0].originalName" :height="'unset'" :width="'100%'" :class="{fullscreen: isFullscreen}" />
        <img
          v-else
          src="https://media.istockphoto.com/id/1396039964/vector/no-image-vector-symbol-missing-available-icon-no-gallery-for-this-moment-placeholder.jpg?b=1&s=170667a&w=0&k=20&c=hzLqz1qI7UtmGgCRRdGXghrNPE8zg8a0D6SgRQ8AiIA="
          style="margin-left: 35%; width: 30%"
        >
        <v-btn v-if="isFullscreen" style="position:fixed; left:0; top: 0; margin: 5px; z-index: 100" color="#2962FF" dark fab @click="fullscreen()">
          <v-icon dark large>
            mdi-fullscreen
          </v-icon>
        </v-btn>
        <v-container>
          <v-row justify="center" style="flex: 0 0 67px">
            <v-col cols="6" align="center" class="pa-0">
              <h2>
                {{ $t('Amount') }}
              </h2>
              <v-text-field
                v-model="amount"
                name="amount"
                type="text"
                :readonly="true"
                class="centered-input pa-0 mt-0 ml-6 mr-6"
                style="font-size: 15pt;padding: 0"
                @click="openModal"
              />
            </v-col>
            <v-col cols="6" align="center" class="pa-0">
              <h2>
                {{ $t('Due Date') }}
              </h2>
              <v-text-field
                v-model="date"
                name="date"
                type="text"
                class="centered-input pa-0 mt-0 ml-6 mr-6"
                style="font-size: 15pt;padding: 0"
                :readonly="readOnlyDueDate"
                @click="openModalDueDate"
              />
              <v-dialog
                ref="dialogPayment"
                v-model="modal"
                :return-value.sync="date"
                persistent
                width="290px"
                contenteditable="true"
              >
                <v-date-picker v-model="date" scrollable :readonly="readOnlyDueDate">
                  <v-spacer />
                  <v-btn text color="#FF6961" @click="modal = false">
                    {{ $t('Cancel') }}
                  </v-btn>
                  <v-btn text color="primary" @click="savedueDate()">
                    {{ $t('OK') }}
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col v-if="iAmThePayer(currentInvoice) && addInvoiceToMarket" cols="6" align="center" class="pa-0">
              <h2>
                {{ $t('InvoiceView.Return amount') }}
              </h2>
              <v-text-field
                v-model="initialAmmount"
                readonly
                type="text"
                class="centered-input pa-0 mt-0 ml-6 mr-6"
                style="font-size: 15pt;padding: 0"
                disabled
              />
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card elevation="12" class="justify-center">
          <v-card-title class="justify-center">
            <span class="headline">{{ $t('Amount') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="center">
                <v-col cols="12">
                  <v-text-field
                    ref="formValue"
                    v-model="amount"
                    name="amount"
                    required
                    type="number"
                    prepend-icon="mdi-cash"
                    :label="$t('Amount')"
                    outlined
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="closeModal">
              {{ $t('Close') }}
            </v-btn>
            <v-btn color="primary" @click="saveAmount()">
              {{ $t('Save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-speed-dial
      v-if="!isFullscreen"
      v-model="fab"
      style="position:absolute;left:0; top: 0; margin-left: 5px; z-index: 100; width: auto; "
      direction="bottom"
      :open-on-hover="false"
      transition="slide-x-transition"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          class="btn-primary"
          dark
          fab
          @click="changeOpacity"
        >
          <v-icon class="fa-rotate-90" style="font-size: 50px; margin-left: 45px">
            mdi-settings-helper
          </v-icon>
        </v-btn>
      </template>
      <v-container style="width: 350px">
        <v-row v-if="isArchived" style="padding: 0">
          <v-col cols="2" style="padding: 0" @click="unarchive()">
            <v-btn fab small dark class="btn-primary">
              <v-icon dark size="25px">
                mdi-archive-arrow-up
              </v-icon>
            </v-btn>
          </v-col>
          <v-col align-self="center" cols="4" style="margin-top: 10px; padding: 0" @click="unarchive()">
            <p :style="{color: colorOptions, 'font-weight': 'bold'}">
              {{ $t('Unarchive') }}
            </p>
          </v-col>
        </v-row>
        <v-row v-if="haveRelatedInvoice" style="padding: 0">
          <v-col cols="2" style="padding: 0" @click="goRelatedInvoice()">
            <v-btn fab small dark class="btn-primary">
              <v-icon dark size="25px">
                mdi-receipt-text-outline
              </v-icon>
            </v-btn>
          </v-col>
          <v-col align-self="center" cols="4" style="margin-top: 10px; padding: 0" @click="goRelatedInvoice()">
            <p :style="{color: colorOptions, 'font-weight': 'bold'}">
              {{ $t('RelatedInvoice') }}
            </p>
          </v-col>
        </v-row>
        <v-row style="padding: 0">
          <v-col cols="2" style="padding: 0" @click="fullscreen()">
            <v-btn class="btn-primary" fab small dark>
              <v-icon dark size="25px">
                mdi-fullscreen
              </v-icon>
            </v-btn>
          </v-col>
          <v-col align-self="center" cols="4" style="margin-top: 10px; padding: 0" @click="fullscreen()">
            <p :style="{color: colorOptions, 'font-weight': 'bold'}">
              {{ $t('InvoiceView.Fullscreen') }}
            </p>
          </v-col>
        </v-row>
        <v-row v-if="!isArchived && isArchivable" style="padding: 0">
          <v-col cols="2" style="padding: 0" @click="archive()">
            <v-btn class="btn-primary" fab dark small>
              <v-icon dark size="25px">
                mdi-archive-arrow-down
              </v-icon>
            </v-btn>
          </v-col>
          <v-col align-self="center" cols="4" style="margin-top: 10px; padding: 0" @click="archive()">
            <p :style="{color: colorOptions, 'font-weight': 'bold'}">
              {{ $t('invoice.arxivar') }}
            </p>
          </v-col>
        </v-row>
        <v-row v-if="canEdit" style="padding: 0">
          <v-col cols="2" style="padding: 0" @click="hideInvoice()">
            <v-btn class="btn-primary" fab small dark>
              <v-icon v-if="canEdit" large>
                mdi-trash-can-outline
              </v-icon>
            </v-btn>
          </v-col>
          <v-col align-self="center" cols="4" style="margin-top: 10px; padding: 0" @click="hideInvoice()">
            <p :style="{color: colorOptions, 'font-weight': 'bold'}">
              {{ $t('Delete') }}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-speed-dial>
  </div>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";
import InvoiceImage from "../components/invoice/InvoiceImage";
import moment from "moment";
import InvoiceMissingInformation from "../components/InvoiceMissingInformation";
import SmartRepository from "@/repositories/SmartRepository";
import Hash from "object-hash";
export default {
    name: "InvoiceView",
    components: { InvoiceImage,  InvoiceMissingInformation},
    data () {
        return {
            showAlert: false,
            isArchived: null,
            isArchivable: null,
            dialogMissingInv: false,
            loading: false,
            fab: false,
            opacityBackground: 1,
            modal: null,
            date: null,
            files: null,
            currentInvoice: null,
            invoiceTypeClient: false,
            isFullscreen: false,
            data: [],
            options: false,
            dialog: false,
            actualAmount: '',
            addInvoiceToMarket: null,
            amount: "",
            outstandingAmmount: "",
            invoices: [],
            readonly: false,
            readOnlyDueDate: false,
            bypayDisabled: true,
            forwardDisabled: true,
            payed: false,
            haveRelatedInvoice: false,
            initialAmmount: 0,
            relatedInvoice: null,
            chat: null,
            file: null
        };
    },
    computed: {
        color () {
            return (this.$vuetify.theme.dark) ? this.$vuetify.theme.themes.dark.background : this.$vuetify.theme.themes.light.background;
        },
        colorOptions () {
            return (this.$vuetify.theme.dark) ? "white" : "black";
        },
        canEdit () {
            return this.outstandingAmmount === this.amount && this.$user;
        },
        iReceiver () {
            return this.currentInvoice.receiver._id.toString() === this.$user._id.toString();
        },
    },
    watch: {
        $route () {
            console.log("hola?");
            this.fetch(this.$route.query.invoiceId);
        },
        invoiceTypeClient: function (val) {
            this.invoiceTypeChanged(val);
        },
        fab: function (val) {
            if (!val) {
                this.opacityBackground = 1;
            } else {
                this.opacityBackground = 0.2;
            }
        }
    },
    created () {
        if (this.$route.query && this.$route.query.invoiceId) {
            this.fetch(this.$route.query.invoiceId);
        }
    },
    methods: {
        //Fetch & MOD
        fetch (invoiceId) {
            ApiRepository.getChatFromInvoice(invoiceId)
                .then((res) => {
                    this.chat = res.data.chat;
                });
            if (this.$user && this.$user.cif) {
                ApiRepository.isArchived(invoiceId, this.$user.cif)
                    .then((res) => {
                        this.isArchived = res.data.isArchived;
                    });
            }
            ApiRepository.getInvoiceById(invoiceId)
                .then((res) => {
                    this.currentInvoice = res.data.invoice;
                    const currentFactoring = this.currentInvoice.relatedFactorings[this.currentInvoice.relatedFactorings.length - 1];
                    if (this.iAmThePayerFactoring(currentFactoring) || this.iAmTheMiddleFactoring(currentFactoring)) {
                        this.isArchivable = currentFactoring.payerPaymentToReceiver === 2 && currentFactoring.acceptedBy === 3 || this.currentInvoice.relatedFactorings.length === 0;
                    } else if (this.iAmTheReceiverFactoring(currentFactoring)) {
                        this.isArchivable = currentFactoring.payerPaymentToReceiver === 2 && currentFactoring.acceptedBy === 3 && this.currentInvoice.outstandingAmmount === 0 || this.currentInvoice.relatedFactorings.length === 0;
                    } else {
                        this.isArchivable = this.currentInvoice.relatedFactorings.length === 0;
                    }
                    this.files = res.data.files;
                    console.log(res.data);
                    this.update();

                    if (this.$route.params.byppay) {
                        this.openModals();
                    }
                    this.showAlert = !this.invoiceAllData();
                    this.$forceUpdate();
                    this.lastCompensationCompleted();

                    if (res.data.invoice.relatedInvoice) {
                        this.haveRelatedInvoice = true;
                        this.relatedInvoice = res.data.invoice.relatedInvoice;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            console.log(this.files[0]);
        },
        invoiceTypeChanged (newType) {
            const type = newType ? Constants.INVOICE.TYPE_SENT : Constants.INVOICE.TYPE_RECEIVED;
            if (type !== (this.iAmThePayer(this.currentInvoice) ? Constants.INVOICE.TYPE_RECEIVED : Constants.INVOICE.TYPE_SENT)) {
                ApiRepository.updateInvoiceType(this.currentInvoice._id, type)
                    .then((response) => {
                        if (response.data.invoice) {
                            this.update();
                        }
                    })
                    .catch((err) => {
                        let msg = "";
                        if (err.response.data.errorCode === Constants.ERRORS.ERROR_INVOICE_NOT_FOUND)
                            msg = this.$t('InvoiceView.Invoice not found');
                        else if (err.response.data.errorCode === Constants.ERRORS.ERROR_GENERIC)
                            msg =  this.$t('ERROR: Something went wrong');
                        this.$root.$emit('show-snackbar', {message: msg, color: 'error'});
                        this.fetch(this.currentInvoice._id);
                    });
            }
        },
        hideInvoice () {
            this.$root.$emit('show-confirmation-modal', {
                title: this.$t('Confirmation'),
                message: this.$t('Do you want to delete this invoice?'),
                yes: () => {
                    ApiRepository.hideInvoice(this.currentInvoice._id)
                        .then(() => {
                            this.$router.push({name: 'home', replace: true});
                        })
                        .catch((err) => {
                            let msg = "";
                            if (err.response.data.errorCode === Constants.ERRORS.ERROR_PAYING_INVOICE)
                                msg = this.$t('Error paying invoice');
                            else if (err.response.data.errorCode === Constants.ERRORS.INVALID_STATUS_CHANGE_USER)
                                msg = this.$t('Invalid status change');
                            else
                                msg =  this.$t('ERROR: Something went wrong');
                            this.$root.$emit('show-snackbar', {message: msg, color: 'error'});
                        });
                },
            });
        },
        savedueDate () {
            this.modal = false;
            if (this.currentInvoice.status <= 1) {
                this.$refs.dialogPayment.save(this.date);
                ApiRepository.updatedueDate(this.currentInvoice._id, this.date).then(() => {
                    this.fetch(this.currentInvoice._id);
                }).catch((err) => {
                    let msg = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_INVOICE_NOT_FOUND)
                        msg = this.$t('InvoiceView.Invoice not found');
                    else if (err.response.data.errorCode === Constants.ERRORS.ERROR_GENERIC)
                        msg = this.$t('ERROR: Something went wrong');
                    else if (err.response.data.errorCode === Constants.ERRORS.ERROR_INVOICE_NOT_EDITABLE)
                        msg = this.$t('InvoiceView.ERROR: Non-editable invoice');
                    this.$root.$emit('show-snackbar', {message: msg, color: 'error'});
                    this.fetch(this.currentInvoice._id);
                });
            }
        },
        saveAmount () {
            ApiRepository.updateAmount(this.currentInvoice._id, this.amount)
                .then(() => {
                    this.closeModal();
                })
                .catch((err) => {
                    let msg = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_INVOICE_NOT_FOUND)
                        msg = this.$t('InvoiceView.Invoice not found');
                    else if (err.response.data.errorCode === Constants.ERRORS.ERROR_GENERIC)
                        msg = this.$t('ERROR: Something went wrong');
                    this.$root.$emit('show-snackbar', {message: msg, color: 'error'});
                });
        },

        //MODALS
        missingInformation () {
            this.$root.$emit('changeTabEvent', 1);
        },
        closeModalInvoice () {
            this.dialogMissingInv = false;
        },
        openModals () {
            if (!this.bypayDisabled || !this.forwardDisabled) {
                this.compensate();
            }
        },
        openModal () {
            if (this.canEdit) {
                this.dialog = true;
            }
        },
        openModalDueDate () {
            if (!this.readOnlyDueDate) {
                this.modal = true;
            }
        },
        closeModal () {
            if (this.currentInvoice.amount) {
                this.amount = this.currentInvoice.amount;
            } else {
                this.amount = "";
            }
            this.outstandingAmmount = this.amount;
            this.dialog = false;
        },
        remind () {
            this.$refs.optionsModal.show(this.currentInvoice._id);
        },
        cancel () {
            const title = this.$t('Confirmation');
            const message = this.$t('InvoiceView.Do you want to cancel this bypay?');
            const button = false;
            this.$root.$emit('show-confirmation-modal', {
                title: title,
                message: message,
                oneButton: button,
                yes: () => {
                    this.$emit('startLoading');
                    const nextStatus = Constants.FACTORING.STATUS_DISCARDED;
                    ApiRepository.updateFactoring(this.currentInvoice.relatedFactoring._id, nextStatus)
                        .then(() => {
                            this.$root.$emit('show-snackbar', {message: this.$t('Succes.Bypay deleted successfully!')});
                            this.fetch(this.currentInvoice._id);
                        })
                        .catch(() => {
                            this.$root.$emit('show-snackbar', {message: this.$t('Error.Error deleting bypay'), color: 'error'});
                        });
                },
            });
        },
        async createChat () {
            console.log(this.$route.query.invoiceId);
            await ApiRepository.createChat(this.$user._id, this.$route.query.invoiceId)
                .then((res) => {
                    console.log("aaa");
                    console.log(res);
                    this.chat = res.data.chat;
                    this.goChat();
                });
        },
        //NAVIGATION
        fullscreen () {
            this.$root.$emit('fullscreen');
            this.isFullscreen = !this.isFullscreen;
            this.opacityBackground = 1;
            this.fab = false;
        },
        archive () {
            ApiRepository.archivateInvoice(this.currentInvoice._id, this.$user.cif)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Bypay archivated successfully!')});
                    this.$router.push({name: 'MainView', replace: true});
                })
                .catch(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error: can\'t archivate bypay'), color: 'error'});
                });
        },
        unarchive () {
            ApiRepository.unarchivateInvoice(this.currentInvoice._id, this.$user.cif)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Bypay unarchivated successfully!')});
                    this.$router.push({name: 'MainView', replace: true});
                })
                .catch(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error: can\'t unarchivate bypay'), color: 'error'});
                });
        },
        goRelatedInvoice () {
            this.$router.push({name: 'viewInvoice', query: {invoiceId: this.relatedInvoice}, replace: true});
            this.fetch(this.$route.query.invoiceId);
        },
        goUploadInvoice () {
            this.$router.push({name: 'imageInvoice', replace: true});
        },
        goMyInvoices () {
            this.$router.push({name: 'invoices', replace: true});
        },
        goToDetail () {
            if (this.$user) {
                this.$router.push({name: 'invoice', params: {id: this.currentInvoice._id}, replace: true});
            } else {
                this.askLogin();
            }
        },
        isIOS () {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        },
        changeOpacity () {
            this.opacityBackground === 1 ? this.opacityBackground = 0.2 : this.opacityBackground = 1;
        },
        seeInvoices () {
            this.$router.push({name: 'invoices', replace: true});
        },
        newInvoice () {
            this.$router.push({name: 'test', replace: true});
        },
        compensate () {
            if (this.currentInvoice) {
                this.$router.push({name: 'CompensationSteper', params: {invoiceId: this.currentInvoice._id}});
            }
        },
        invoiceAllData () {
            return this.currentInvoice.amount !== 0 && this.currentInvoice.payer && this.currentInvoice.receiver && (this.currentInvoice.dueDate !== undefined && this.currentInvoice.dueDate != null && this.currentInvoice.dueDate !== '');
        },
        update () {
            if (!this.currentInvoice) return;
            this.invoiceTypeClient = !this.iAmThePayer(this.currentInvoice);
            if (this.currentInvoice.amount) {
                this.amount = this.currentInvoice.amount;
                this.outstandingAmmount = this.currentInvoice.outstandingAmmount;
                this.readonly = true;
            } else {
                this.amount = "";
                this.outstandingAmmount = "";
                this.readonly = false;
            }
            if (this.outstandingAmmount === 0) {
                this.bypayDisabled = true;
                this.forwardDisabled = true;
            } else {
                this.bypayDisabled = this.invoiceTypeClient;
                this.forwardDisabled = !this.invoiceTypeClient;
            }
            this.currentInvoice.dueDate ?  this.date = moment(this.currentInvoice.dueDate ).format("YYYY-MM-DD").substr(0, 10) : this.date = null;
            this.readOnlyDueDate = this.currentInvoice.status > 2 || !this.$user;
            this.actualAmount = this.amount;
        },
        iAmThePayer (invoice) {
            return this.$user && invoice && invoice.payer && invoice.payer._id.toString() === this.$user._id.toString();
        },
        iAmTheMiddleFactoring (factoring) {
            return factoring && this.$user && factoring.middle._id === this.$user._id;
        },
        iAmThePayerFactoring (factoring) {
            return factoring && this.$user && factoring.payer._id === this.$user._id;
        },
        iAmTheReceiverFactoring (factoring) {
            return factoring && this.$user && factoring.receiver._id === this.$user._id;
        },
        askLogin () {
            this.$root.$emit('show-confirmation-modal', {
                title: this.$t('Login'),
                message: this.$t('In order to do this option you need to login, Do you want to login?'),
                oneButton: true,
                yes: () => {
                    this.$router.push({name: 'Login', replace: true});
                }
            });
        },
        //
        lastCompensationCompleted () {
            return this.currentInvoice && this.currentInvoice.relatedFactorings.length > 0 ? this.currentInvoice.relatedFactorings[this.currentInvoice.relatedFactorings.length - 1].payerPaymentToReceiver === 2 : true;
        },
        payCollateral () {
            const mySTR = this.currentInvoice._id.toString();
            const hash = '0x' + Hash.sha1(mySTR);
            SmartRepository.transaction(Constants.contractMarketplace, "payInvoice", [hash])
                .then((res) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Collateral payed'), color: 'success'});
                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error: pay collateral'), color: 'error'});
                });
        },
    },
    sockets: {
        REFRESH_BROWSE () {
            console.log("REFRESH_BROWSE");
            this.fetch(this.currentInvoice._id);
        },
        REFRESH_payerPaymentToReceiver () {
            console.log("REFRESH_payerPaymentToReceiver");
            this.fetch(this.currentInvoice._id);
        },
        REFRESH_payerPaymentToPlatform () {
            console.log("REFRESH_payerPaymentToPlatform");
            this.fetch(this.currentInvoice._id);
        },
        REFRESH_middlePaymentToReceiverUpdate () {
            console.log("REFRESH_middlePaymentToReceiverUpdate");
            this.fetch(this.currentInvoice._id);
        },
        REFRESH_middlePaymentToPlatformUpdate () {
            console.log("REFRESH_middlePaymentToPlatformUpdate");
            this.fetch(this.currentInvoice._id);
        },
        REFRESH_payerPaymentToMiddleUpdate () {
            console.log("REFRESH_payerPaymentToMiddleUpdate");
            this.fetch(this.currentInvoice._id);
        }
    },
};
</script>

<style scoped>
.my-custom-dialog {
    align-self: flex-start;
}
.background-color {
    background-color: var(--v-background-base) !important;
}
</style>

<style>
.v-speed-dial__list {
    align-items: flex-start;
}
.custom-switch {
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 1.52px;
}

.custom-switch label {
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 1.52px;
}

.scrolling-wrapper {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    height: 100%;
    width: 100%;
    -webkit-overflow-scrolling: touch;
}

.card {
    display: inline-block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 1px none black;
    border-right-style: solid;
}

.centered-input input {
    text-align: center
}

.action-buttons div {
    margin-right: 5px;
    float: left;
}

.bottom-card .v-text-field input{
    padding: 0px !important;
}
.fullscreen {
    z-index: 99;
    width: 100%;
    height: 100% !important;
    position: fixed;
    top: 0;
    left: 0;
}

.test-class {
    transform: unset!important;
}
</style>
